import type { Coord } from "@dailywars/core/engine";
import { useMemo, useRef } from "react";

import type { ScrollChromeRefs } from "#/components/game/gameCanvas/boardViewport";
import { useGameSelector } from "#/game/GameStoreProvider";
import type { StoreState } from "#/game/store/types";

function boardScrollFocusCoord({
  animation,
  scrollFocusTile,
}: {
  animation: StoreState["animation"];
  scrollFocusTile: Coord | null;
}): Coord | null {
  if (animation?.type === "move") return animation.from;
  if (animation?.type === "attackFx") return animation.targetTile;
  if (animation?.type === "repairFx" && animation.numbers.length > 0)
    return animation.numbers[0]!.tile;
  return scrollFocusTile;
}

export function usePlayMapBoardChrome() {
  const animation = useGameSelector((s) => s.animation);
  const scrollFocusTile = useGameSelector((s) => s.scrollFocusTile);
  const boardScrollFocus = useMemo(
    () => boardScrollFocusCoord({ animation, scrollFocusTile }),
    [animation, scrollFocusTile],
  );

  const topDockRef = useRef<HTMLDivElement | null>(null);
  const bottomDockRef = useRef<HTMLDivElement | null>(null);
  const scrollChrome = useMemo<ScrollChromeRefs>(
    () => ({
      topDockRef,
      bottomDockRef,
    }),
    [],
  );

  return {
    boardScrollFocus,
    topDockRef,
    bottomDockRef,
    scrollChrome,
  };
}
